export const GET_HOME_CURATED_LIST = 'HOME_CURATED_LIST';
export const GET_CURATED_ALBUMS = 'GET_CURATED_ALBUMS';
export const GET_CURATED_SONGS = 'GET_CURATED_SONGS';
export const GET_GENRE_CURATED_ALBUMS = 'GET_GENRE_CURATED_ALBUMS';
export const GET_SUGGESTED_CURATED_ALBUMS = 'GET_SUGGESTED_CURATED_ALBUMS';